import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'semantic-ui-react'
import { MilkMoneyQuery } from '~/QueryHooks/MilkMoneyQuery'
import { DownloadService } from '~/api/services/downloadFiles'
import Dialog from '~/components/Dialog'
import { KeyLabelType } from '~/types'
import { getUsersBrowserData, handleErrors } from '~/utils/helpers'

interface MGAModalProps {
  open: boolean
  handleClose: () => void
  monthSelected: KeyLabelType
}

const MGAModal: React.FC<MGAModalProps> = (props) => {
  const { t } = useTranslation()
  const { open, handleClose } = props
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [generatingFile, setGeneratingFile] = useState(false)
  const [printData, setPrintData] = useState({
    truckNumber: '',
    businessPaper: 0
  })

  const {
    data: printSettings,
    isLoading: isLoading
  } = MilkMoneyQuery.getInvoicePrintSettings()

  useEffect(() => {
    setIsDialogOpen(open)
  }, [open])

  function renderForm() {
    return <Form>
      <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
        <Form.Dropdown
          required
          placeholder={t('Select truck number')}
          label={t('Truck number')}
          value={printData.truckNumber}
          options={printSettings?.truckNumbers?.map(item => ({ value: item, text: item }))}
          selection
          width={'8'}
          selectOnBlur={false}
          //@ts-ignore
          onChange={(e, data) => setPrintData({ ...printData, truckNumber: data.value })}
        />
        <Form.Checkbox
          required
          label={t('Print on business paper?')}
          checked={Boolean(printData.businessPaper)}
          onChange={(e, data) => setPrintData({ ...printData, businessPaper: data.checked ? 1 : 0 })}
        />
      </div>
    </Form>
  }

  function handleCloseModal() {
    setPrintData({
      truckNumber: '',
      businessPaper: 0
    })
    handleClose()
  }

  async function handlePrintSubmit() {
    setGeneratingFile(true)
    const userData = getUsersBrowserData()
    try {
      const payload = {
        ...printData,
        ...userData,
        month: props.monthSelected?.key
      }
      await DownloadService.downloadFileWithName('milk-money/milk-payment/invoices/print-preview/pdf', payload)
      handleCloseModal()
    } catch (error) {
      handleErrors(error)
    }
    setGeneratingFile(false)
  }

  return <Dialog
    isDialogOpen={isDialogOpen}
    isLoading={isLoading || generatingFile}
    handleClose={() => handleCloseModal()}
    textHeader={t('MGA sample print for {{month}}', { month: props.monthSelected?.label })}
    disableSubmit={printData.truckNumber === ''}
    textClose={t('Close')}
    htmlContent={true}
    textSubmit={t('Print MGA')}
    minHeight='120px'
    noScrollingContent
    textContent={<>
      {renderForm()}
    </>}
    handleSubmit={() => handlePrintSubmit()}
  />
}
export default MGAModal